module.exports = __webpack_public_path__ + "img/agency-vip-bg.255fd3cb.png";